import React from 'react';
import { Select } from 'antd';
import { CustomComponentProps, FieldOption } from '../types';

/**
 * Custom Select wrapper component
 */
export interface MySelectProps extends CustomComponentProps {
  options?: FieldOption[];
  mode?: 'multiple' | 'tags';
  allowClear?: boolean;
  showSearch?: boolean;
  filterOption?: boolean | ((input: string, option: any) => boolean);
  loading?: boolean;
  size?: 'small' | 'middle' | 'large';
  onSearch?: (value: string) => void;
}

const MySelect: React.FC<MySelectProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  readonly,
  options = [],
  mode,
  allowClear = true,
  showSearch = true,
  filterOption = true,
  loading,
  size = 'middle',
  onSearch,
  ...rest
}) => {
  const handleChange = (selectedValue: any) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  // Default filter function
  const defaultFilterOption = (input: string, option: any) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled || readonly}
      options={options}
      mode={mode}
      allowClear={allowClear}
      showSearch={showSearch}
      filterOption={
        typeof filterOption === 'boolean'
          ? filterOption
            ? defaultFilterOption
            : false
          : filterOption
      }
      loading={loading}
      size={size}
      onSearch={onSearch}
      {...rest}
    />
  );
};

export default MySelect;
